<template>
<div>
  <div class="tbl-scroll">
    <table class="pulse-tbl">
      <thead>
        <tr>
          <th class="tbl-th">Amount (excl. tax)</th>
          <th class="tbl-th">Status</th>
          <th class="tbl-th">Expected payout date</th>
          <th class="tbl-th">Created</th>
          <th class="tbl-th"></th>
        </tr>
      </thead>
      <tbody v-if="loading">
        <tr v-for="n in 5" :key="n">
          <td colspan="5"><div class="skel-row"></div></td>
        </tr>
      </tbody>
      <tbody v-else-if="paginated.length === 0">
        <tr>
          <td colspan="5" class="tbl-empty">
            <div class="tbl-empty-inner">
              <Icon name="inbox" :size="22" class="tbl-empty-icon" />
              <div>No payouts found</div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="item in paginated" :key="item.stripe_key" class="tbl-row">
          <td>{{ item.currency.toUpperCase() }} {{ $fmtN(item.total, 2) }}</td>
          <td>
            <span class="status-pill" :class="'status-pill--' + item.status">
              {{ statusLabel(item.status) }}
            </span>
          </td>
          <td>{{ item.arrival_at | utc_to_local_datetime("DD-MM-YYYY") }}</td>
          <td>{{ item.created_at | utc_to_local_datetime("DD-MM-YYYY") }}</td>
          <td class="tbl-num">
            <button
              class="btn-icon"
              :disabled="!payoutAccount"
              title="Download PDF"
              @click="downloadPdf(item)"
            >
              <Icon name="file-text" :size="14" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="tbl-pagination">
    <button class="btn btn-ghost btn-sm" :disabled="page === 0" @click="prevPage">Previous</button>
    <button class="btn btn-ghost btn-sm" :disabled="page >= pageCount - 1" @click="nextPage">Next</button>
  </div>
</div>
</template>

<script>
import utc_to_local_datetime from "@/helpers/filters/utc_to_local_datetime";
import { jsPDF } from "jspdf";

const STATUS_LABELS = {
  paid: "Paid",
  pending: "Pending",
  in_transit: "In transit",
  canceled: "Cancelled",
};

export default {
  filters: {
    utc_to_local_datetime,
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => {
        return [];
      }
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
      size: { type: Number, required: false, default: 10 },

     firstLoad: {
      type: Boolean,
      required: false,
      default: false
    },
    payoutAccount: {
      // type: Object,
      required: false,
      default: null
    }
  },
  data: () => ({
    pdfLine: 0,
    page: 0
  }),
  methods: {
    statusLabel(status) {
      return STATUS_LABELS[status] || status;
    },
     nextPage() {
       this.$emit('next')
      this.page++;
    },
    prevPage() {
      this.page--;
    },
    setLine(length = 10) {
      this.pdfLine += length;
    },
    downloadPdf(payout) {
      // Reset default line
      this.pdfLine = 10;

      // Use local number format
      let amount = this.$fmtN(payout.amount, 2);
      let vat = this.$fmtN(payout.vat, 2);

      let pdfName =
        "Payout " +
        this.$options.filters.utc_to_local_datetime(
          payout.created_at,
          "DD-MM-YYYY"
        );

      let doc = new jsPDF();
      const defaultFont = doc.getFont();
      doc.setFontSize(20);
      doc.text("Make Influence payout", 7, this.pdfLine);

      // Payout from
      doc.setFontSize(10);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "bold");
      this.setLine(10);
      doc.text("Sender", 7, this.pdfLine, "left");

      // info style
      doc.setFontSize(10);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");

      this.setLine(5);
      doc.text("Make Influence ApS", 7, this.pdfLine, "left");
      this.setLine(5);
      doc.text("DK44924064", 7, this.pdfLine, "left");
      this.setLine(5);
      doc.text("Badstuegade 1D", 7, this.pdfLine, "left");
      this.setLine(5);
      doc.text("8000 Aarhus C", 7, this.pdfLine, "left");
      this.setLine(5);
      doc.text("DK", 7, this.pdfLine, "left");

      // Payout to header style
      doc.setFontSize(10);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "bold");
      this.setLine(10);
      doc.text("Recipient", 7, this.pdfLine, "left");

      // Payout to info style
      doc.setFontSize(10);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");

      let company = this.payoutAccount.company ?? "";
      let address = this.payoutAccount.address ?? "";
      let postalCode = this.payoutAccount.postal_code ?? "";
      let city = this.payoutAccount.city ?? "";
      let country = "";

      if (this.payoutAccount.account_type === 1 && company) {
        this.setLine(5);
        doc.text("" + company, 7, this.pdfLine, "left");
      }

      if (this.payoutAccount.tax_id) {
        this.setLine(5);
        doc.text("" + this.payoutAccount.tax_id, 7, this.pdfLine, "left");
      }

      this.setLine(5);
      doc.text(address, 7, this.pdfLine, "left");
      this.setLine(5);
      doc.text(postalCode + " " + city, 7, this.pdfLine, "left");
      this.setLine(5);
      doc.text(country, 7, this.pdfLine, "left");
      this.setLine(5);

      if (this.payoutAccount.email) {
        doc.text("" + this.payoutAccount.email, 7, this.pdfLine, "left");
      }

      // Payout info
      doc.setFontSize(10);

      // Payout ID
      this.setLine(20);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "bold");
      doc.text("Payout-id", 7, this.pdfLine, "left");
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");
      doc.text("" + payout.stripe_key, 45, this.pdfLine, "left");

      // Payout creation
      this.setLine(5);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "bold");
      doc.text("Dato", 7, this.pdfLine, "left");
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");
      doc.text(
        "" +
          this.$options.filters.utc_to_local_datetime(
            payout.created_at,
            "DD-MM-YYYY"
          ),
        45,
        this.pdfLine,
        "left"
      );

      // Payout arrival
      this.setLine(5);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "bold");
      doc.text("Payout date", 7, this.pdfLine, "left");
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");
      doc.text(
        "" +
          this.$options.filters.utc_to_local_datetime(
            payout.arrival_at,
            "DD-MM-YYYY"
          ),
        45,
        this.pdfLine,
        "left"
      );

      // Headline styles
      doc.setFontSize(10);
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "bold");

      this.setLine(20);

      let width = doc.internal.pageSize.getWidth();

      let rightCol1 = width - 10;
      let rightCol2 = width - 40;
      let rightCol3 = width - 70;
      let rightCol4 = width - 100;

      // Line header - Unit text
      doc.text("Product", rightCol4, this.pdfLine, "right");
      // Line header - Unit price
      doc.text("Unit price", rightCol3, this.pdfLine, "right");
      // Line header - Vat
      doc.text("VAT", rightCol2, this.pdfLine, "right");
      // Line header - Total
      doc.text("Total", rightCol1, this.pdfLine, "right");

      // Line styles
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");
      // Set new line
      this.setLine(6);

      // Line - unit text
      doc.text("Total commission", rightCol4, this.pdfLine, "right");
      // Line - unit price
      doc.text("" + amount, rightCol3, this.pdfLine, "right");
      // Line - Vat
      doc.text(vat, rightCol2, this.pdfLine, "right");
      // Line - Total
      doc.text("" + amount, rightCol1, this.pdfLine, "right");

      // Headline styles
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");
      doc.setFontSize(10);

      // Line header - Total without vat
      this.setLine(25);
      doc.text("Total ex. VAT", rightCol2, this.pdfLine, "right");
      // Line - Total without vat
      doc.text("" + amount, rightCol1, this.pdfLine, "right");

      // Line header - Total vat
      this.setLine(6);
      doc.text("25% VAT", rightCol2, this.pdfLine, "right");
      // Line - Total vat
      doc.text("" + vat, rightCol1, this.pdfLine, "right");

      // Line header - Total
      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "bold");
      this.setLine(6);
      doc.text("Total incl. VAT", rightCol2, this.pdfLine, "right");
      // Line - Total
      doc.text(
        "" + this.$fmtN(payout.amount + payout.vat, 2), 
        rightCol1,
        this.pdfLine,
        "right"
      );

      doc.setFont(defaultFont.fontName, defaultFont.fontStyle, "normal");

      // Download
      doc.save(pdfName + ".pdf");
    }
  },
  computed: {
    pageCount() {
      let l = this.items.length,
        s = this.size;
      return Math.round(l / s);
    },
    paginated() {
      const start = this.page * this.size,
        end = start + this.size;
      return this.items.slice(start, end);
    }
  }
};
</script>

<style scoped>
.tbl-scroll { overflow-x: auto; }
.pulse-tbl { width: 100%; border-collapse: collapse; font-size: 13px; }
.tbl-th {
  padding: 10px 16px; text-align: left; font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: .06em; color: var(--ink-3);
  border-bottom: 1px solid var(--line); white-space: nowrap;
}
.tbl-row td { padding: 10px 16px; color: var(--ink-1); border-bottom: 1px solid var(--line); }
.tbl-row:last-child td { border-bottom: none; }
.tbl-row:hover td { background: color-mix(in srgb, var(--line) 50%, transparent); }
.tbl-num { text-align: right; }
.tbl-empty { padding: 32px; text-align: center; color: var(--ink-3); }
.skel-row {
  height: 36px; background: var(--line); border-radius: var(--r-sm);
  animation: pulse 1.4s ease-in-out infinite;
}
@keyframes pulse { 0%,100%{opacity:.6} 50%{opacity:1} }

.status-pill {
  display: inline-block; padding: 3px 10px; border-radius: 99px;
  font-size: 11px; font-weight: 600; text-transform: capitalize;
  background: var(--line); color: var(--ink-2);
}
.status-pill--paid { background: color-mix(in srgb, #10B981 18%, transparent); color: #10B981; }
.status-pill--pending { background: color-mix(in srgb, #F59E0B 18%, transparent); color: #F59E0B; }
.status-pill--in_transit { background: color-mix(in srgb, #3B82F6 18%, transparent); color: #3B82F6; }
.status-pill--canceled { background: color-mix(in srgb, #EF4444 18%, transparent); color: #EF4444; }

.btn-icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 28px; height: 28px; border-radius: var(--r-sm); border: 1px solid var(--line);
  background: var(--surface); color: var(--ink-2); cursor: pointer;
}
.btn-icon:hover:not(:disabled) { background: var(--line); }
.btn-icon:disabled { opacity: .4; cursor: not-allowed; }

.tbl-pagination { display: flex; justify-content: flex-end; gap: 8px; padding: 16px 20px; }
.tbl-empty { padding: 32px; text-align: center; color: var(--ink-3); }
.tbl-empty-inner {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
}
.tbl-empty-icon { color: var(--ink-3); opacity: .6; }
</style>